import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';

@Component({
  selector: 'app-card-services',
  imports: [CommonModule],
  templateUrl: './card-services.component.html',
  styleUrl: './card-services.component.css'
})
export class CardServicesComponent implements OnChanges {
  @Input() imageUrl: string = '';
  @Input() data: {label: string, value:string, img:string, enabled: boolean} | null = null;
  @Output() cardClicked = new EventEmitter<string>();

  isClicked: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data?.enabled) {
      this.isClicked = true;
    }
  }

  onClick(event: string) {
    this.isClicked = !this.isClicked;
    this.cardClicked.emit(event);
  }
}
